import React, { Component } from 'react';
import Boutons from './Boutons';

class SituationFamiliale extends Component{

    constructor ( props ){
        super (props);
        this.state = {
            valide: false,
            prochain : "unavis",
        }
    }

    componentDidMount () {
        this.props.callback( {type: "reinit", valeur: "situation" });
    }    

    action (valeur) {
        switch (valeur){
            case 2:
                this.setState( { prochain: "deuxavis", valide : true });
                break;
            case 4:
                this.setState({ prochain: "autres", valide: true});
                break;
            default:
                this.setState( { prochain: "unavis", valide : true });
                break;
        }
        this.props.callback( {type: "situationFamiliale", valeur: valeur });
    }

    render () {
        const { situationFamiliale, callback } = this.props;
        const { valide, prochain } = this.state;
        return (
            <div className="container">
                <div className="col-sm-12">
                    <h2>2- Situation familiale</h2>
            
                        <label style={{ width: "100%"}}>
                            <input type="radio" name="situationFamiliale" value="1" checked={situationFamiliale.id === 1} onChange={ () => this.action( 1 ) }/>
                            <span> Je vis en couple et nous avons un avis d'imposition commun.</span>
                        </label>
                        <br/>
                        <label>
                            <input type="radio" name="situationFamiliale" value="Non" checked={situationFamiliale.id === 2} onChange={ () => this.action( 2 ) } />
                            <span> Je vis en couple et nous avons chacun notre propre avis d'imposition.</span>
                        </label>
                        <br />
                        <label>
                            <input type="radio" name="situationFamiliale" value="Non" checked={situationFamiliale.id === 3} onChange={ () => this.action( 3 ) } />
                            <span> Je vis seul(e) avec mon(mes) enfant(s) et la lettre T figure sur mon avis d'imposition ou sur le rectificatif fourni par les impôts.</span>
                        </label>
                        <br />
                        <br />
                        <small><i>Si vous êtes dans une autre situation, l’équipe Ordi’Lot devra procéder à une analyse détaillée de votre dossier une fois l’inscription effectuée.
Vous pourrez évidemment refuser l’offre qui vous sera proposée.</i></small>

                        <Boutons retour="initial" suivant={prochain} valide={valide} callback={callback}/>
                </div>
            </div>
        );
    }
}

export default SituationFamiliale;